var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "Task-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 110,
            model: _vm.edit,
            elem: _vm.taskElem,
            rules: _vm.taskRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "任务名称", prop: "name" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入任务名称",
                                      maxlength: "50",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value: _vm.edit.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.edit,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "edit.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "预计体检日期",
                                    prop: "physicalDate",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.edit.physicalDate,
                                      editable: false,
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      placeholder: "预计体检日期",
                                      disabled: _vm.disabled,
                                    },
                                    on: { "on-change": _vm.changePhysicalDate },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "体检人群",
                                    prop: "crowdIds",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        multiple: true,
                                        disabled: _vm.disabled,
                                      },
                                      model: {
                                        value: _vm.edit.crowdIds,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "crowdIds", $$v)
                                        },
                                        expression: "edit.crowdIds",
                                      },
                                    },
                                    _vm._l(_vm.crowdList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "体检学校",
                                    prop: "schoolId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "体检地点",
                                        clearable: "",
                                        filterable: "",
                                        size: "small",
                                        transfer: "true",
                                        "popper-append-to-body": false,
                                        disabled: _vm.disabled,
                                      },
                                      model: {
                                        value: _vm.edit.schoolId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "schoolId",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "edit.schoolId",
                                      },
                                    },
                                    _vm._l(_vm.schoolsList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        staticStyle: {
                                          width: "100%",
                                          "z-index": "9999",
                                        },
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleSchoolChange(item)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "详细地址",
                                    prop: "detailAddress",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入详细地址",
                                      maxlength: "100",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value: _vm.edit.detailAddress,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "detailAddress", $$v)
                                      },
                                      expression: "edit.detailAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    "label-width": 110,
                                    label: "报名开放日期",
                                    prop: "signUpDate",
                                    required: "",
                                  },
                                },
                                [
                                  _c(
                                    "Row",
                                    [
                                      _c(
                                        "Col",
                                        { attrs: { span: "11" } },
                                        [
                                          _c("DatePicker", {
                                            attrs: {
                                              value: _vm.edit.signUpStartDate,
                                              editable: false,
                                              type: "date",
                                              format: "yyyy-MM-dd",
                                              placeholder: "开始日期",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              "on-change":
                                                _vm.changeSignUpStartDate,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "Col",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                          },
                                          attrs: { span: "2" },
                                        },
                                        [_vm._v("~")]
                                      ),
                                      _c(
                                        "Col",
                                        { attrs: { span: "11" } },
                                        [
                                          _c("DatePicker", {
                                            attrs: {
                                              value: _vm.edit.signUpEndDate,
                                              editable: false,
                                              type: "date",
                                              format: "yyyy-MM-dd",
                                              placeholder: "结束日期",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              "on-change":
                                                _vm.changeSignUpEndDate,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "16" } },
                    [
                      _c("TaskTemplate", {
                        ref: "taskTemplate",
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          packagesNames: _vm.packagesNames,
                          "applicable-age-list": _vm.applicableAgeList,
                          taskProject: _vm.taskProjects,
                          packageDisabled: _vm.disabled,
                          itemDisabled: _vm.disabled,
                        },
                        on: { setPackageId: _vm.setPackageId },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }